import { apiClient } from '@/core/api/client';

export type ShareCareGuideResponse = {
  success: true;
  recipientEmail: string;
};

/**
 * Email the care-seeker's navigator care guide (PDF attached) to a recipient.
 * The backend renders this session's care guide — the session must belong to
 * the authenticated caller — and dispatches the share email. JWT-guarded, so
 * guests are gated to signup before this is ever called.
 */
export async function shareCareGuideByEmail(
  sessionId: string,
  recipientEmail: string,
  recipientName?: string,
): Promise<ShareCareGuideResponse> {
  const { data } = await apiClient.post<ShareCareGuideResponse>('/care-plan-pdf/share-email', {
    session_id: sessionId,
    recipientEmail,
    ...(recipientName?.trim() ? { recipientName: recipientName.trim() } : {}),
  });
  return data;
}
